'use strict';

// Vendors imports
import 'slick-carousel/slick/slick.js';
import 'swiper/swiper-bundle.min.js';
import 'jquery.nicescroll/dist/jquery.nicescroll.min.js';
import 'plyr/dist/plyr.min.js';
import select2 from 'select2/dist/js/select2.full.min.js';
select2( window.jQuery );
import ClipboardJS from 'clipboard';

import Swiper from 'swiper';
import SwiperCore, { EffectFade, Parallax, Autoplay, Navigation, Pagination } from 'swiper/core';
SwiperCore.use( [
    EffectFade,
    Parallax,
    Autoplay,
    Navigation,
    Pagination,
] );

// Expose Clipboard and Parallax globally if needed
window.ClipboardJS = ClipboardJS;
window.Parallax = Parallax;

// App modules
import ArchiveFAQ from './archive-faq';
import ArchiveLandingPages from './archive-landing-pages';
import Ball from './ball';
import FacetWP from './facetwp';
import Faq from './faq';
import Forms from './forms';
import FrontPage from './front-page';
import Header from './header';
import HeaderLanding from './header-landing';
import KeyNumbers from './key-numbers';
import LangSwitcher from './lang-switcher';
import NavMobile from './nav-mobile';
import Newsroom from './newsroom';
import Products from './products';
import OrientationTable from './orientation-table';
import Popin from './popin';
import Gutenberg from './gutenberg';
import Select2Init from './select2';
import SliderQuotes from './slider-quotes';
import SmoothScroll from './smooth-scroll';
import SocialSharer from './social-sharer';
import StickyHeader from './sticky-header';
import StickyPush from './sticky-push';
import Testimonies from './testimonies';
import Nav from './nav';
import WebinarsReplays from './webinars-replays';
import WhiteBooks from './white-books';
import Plezi from './plezi';
import Embed from './embed';
import Tracking from './tracking';

document.addEventListener( 'DOMContentLoaded', () => {
    new ArchiveFAQ();
    new ArchiveLandingPages();
    new Ball();
    new FacetWP();
    new Faq();
    new Forms();
    new FrontPage();
    new Header();
    new HeaderLanding();
    new KeyNumbers();
    new LangSwitcher();
    new NavMobile();
    new Newsroom();
    new Products();
    new OrientationTable();
    new Popin();
    new Gutenberg();
    new Select2Init();
    new SliderQuotes();
    new SmoothScroll();
    new SocialSharer();
    new StickyHeader();
    new StickyPush();
    new Testimonies();
    new Nav();
    new WebinarsReplays();
    new WhiteBooks();
    new Plezi();
    new Embed(); // before Tracking, which dispatches the embed consent event
    Tracking.init();
} );
